import { createSlice } from "@reduxjs/toolkit";
import { clearListFilters } from "../../hooks/useSessionPersistedState";
import {
  AUTH_TOKEN_KEY,
  clearAuthEmail,
  clearPendingOrgMfa,
  clearRequiresOrgSelection,
  readPendingOrgMfa,
  readRequiresOrgSelection,
  setPendingOrgMfaContext,
  setRequiresOrgSelection,
} from "../../utils/authSession";

const initialState = {
  isAuthenticated: false,
  sessionChecked: false,
  requiresOrgSelection: readRequiresOrgSelection(),
  pendingOrgFinalize: readPendingOrgMfa(),
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.isAuthenticated = true;
      state.sessionChecked = true;
      state.requiresOrgSelection = !!action.payload?.requiresOrgSelection;
      setRequiresOrgSelection(state.requiresOrgSelection);

      if (typeof action.payload?.pendingOrgFinalize === "boolean") {
        state.pendingOrgFinalize = action.payload.pendingOrgFinalize;

        if (!action.payload.pendingOrgFinalize) {
          clearPendingOrgMfa();
        }
      }
    },
    setPendingOrgFinalize: (state, action) => {
      state.pendingOrgFinalize = true;

      if (action.payload) {
        setPendingOrgMfaContext(action.payload);
      }
    },
    clearPendingOrgFinalize: (state) => {
      state.pendingOrgFinalize = false;
      clearPendingOrgMfa();
    },
    completeOrgSelection: (state) => {
      state.requiresOrgSelection = false;
      state.pendingOrgFinalize = false;
      clearRequiresOrgSelection();
      clearPendingOrgMfa();
    },
    sessionResolved: (state, action) => {
      if (state.sessionChecked) {
        return;
      }

      state.sessionChecked = true;
      state.isAuthenticated = !!action.payload?.authenticated;

      if (!state.isAuthenticated) {
        state.requiresOrgSelection = false;
        state.pendingOrgFinalize = false;
        localStorage.removeItem(AUTH_TOKEN_KEY);
        clearRequiresOrgSelection();
        clearPendingOrgMfa();
        clearAuthEmail();
      }
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.sessionChecked = true;
      state.requiresOrgSelection = false;
      state.pendingOrgFinalize = false;
      localStorage.removeItem(AUTH_TOKEN_KEY);
      clearRequiresOrgSelection();
      clearPendingOrgMfa();
      clearAuthEmail();
      clearListFilters();
    },
  },
});

export const selectSessionReady = (state) =>
  state.auth.isAuthenticated &&
  !state.auth.requiresOrgSelection &&
  !state.auth.pendingOrgFinalize;
export const selectRequiresOrgSelection = (state) =>
  state.auth.requiresOrgSelection;

export const {
  loginSuccess,
  sessionResolved,
  setPendingOrgFinalize,
  clearPendingOrgFinalize,
  completeOrgSelection,
  logout,
} = authSlice.actions;

export default authSlice.reducer;
